export enum BorrowerConfigurationActionType {
  DownloadApiRequestTemplate = 'borrowerConfiguration/downloadApiRequestTemplate',
  DownloadApiRequestTemplateSuccess = 'borrowerConfiguration/downloadApiRequestTemplateSuccess',
  DownloadApiRequestTemplateFailure = 'borrowerConfiguration/downloadApiRequestTemplateFailure',
}
